module.exports = __webpack_public_path__ + "img/logo.fdf66f49.png";